import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useRole, useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IUserRoleLabelProps {
  readonly className?: string;
  readonly id: string;
}

function UserRoleLabel({ className, id }: Readonly<IUserRoleLabelProps>): JSX.Element {
  const { UserRoles } = useStore();
  const { hasPermissionsLicenseOrFlag } = useRole();

  // `users` is a route segment, not a role id, so it must never reach UserRoles.get.
  if (id === 'users') {
    return (
      <div className={className}>{hasPermissionsLicenseOrFlag ? 'Users & Roles' : 'Users'}</div>
    );
  }

  const userRole = UserRoles.get(id);

  return (
    <div className={classNames({ [skeleton]: userRole.isPending }, className)}>{userRole.name}</div>
  );
}

export default observer(UserRoleLabel);
